<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1 myclass" id="شكر-وتقدير">
<h1 style="padding-top:150px"><span dir="rtl">شكر وتقدير</span></h1>
<p><span dir="rtl">شكراً لعائلتي، وأصدقائي، ودار النشر لمساعدتي.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?a7a97f6a